import { http } from '@shared/libs/http'

export type UserRow = {
  id: string
  email: string
  is_active: boolean
}

export type Page<T> = {
  count: number
  next: string | null
  previous: string | null
  results: T[]
}

export async function listUsers(params?: { limit?: number; offset?: number; q?: string }) {
  const { data } = await http.get<Page<UserRow>>('/api/users', { params })
  return data
}

